module.exports = __webpack_public_path__ + "img/rascrut-6.aba86fcf.jpg";